import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { CSSProperties } from 'react';

const upscSkeletonShimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
`;

const SkeletonBar = styled.span<{
  $width?: string;
  $height?: string;
  $radius?: string;
  $block?: boolean;
}>`
  position: relative;
  display: ${({ $block }) => ($block ? 'block' : 'inline-block')};
  overflow: hidden;
  width: ${({ $width }) => $width ?? '100%'};
  height: ${({ $height }) => $height ?? '1rem'};
  border-radius: ${({ $radius }) => $radius ?? '4px'};
  background: var(--color-divider);
  line-height: 1;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      90deg,
      transparent 0%,
      var(--color-base-0) 50%,
      transparent 100%
    );
    animation: ${upscSkeletonShimmer} 1.2s ease-in-out infinite;
  }
`;

export interface UpscCurrentAffairsSkeletonProps {
  width?: string;
  height?: string;
  radius?: string;
  block?: boolean;
  style?: CSSProperties;
}

const UpscCurrentAffairsSkeleton = ({
  width,
  height,
  radius,
  block = true,
  style
}: UpscCurrentAffairsSkeletonProps) => (
  <SkeletonBar
    aria-hidden
    $width={width}
    $height={height}
    $radius={radius}
    $block={block}
    style={style}
  />
);

export default UpscCurrentAffairsSkeleton;
